import {
  actionLoading,
  actionSuccess,
  actionErrored,
  actionReset,
} from 'api/helpers';
import { unAuthRequest, authRequest } from 'api/helpers';
import URL, { getDynamicEndpoint } from 'api/endpoints';

// Fetch ticketing providers
export const FETCH_TICKETING_PROVIDERS = 'FETCH_TICKETING_PROVIDERS';

export const fetchTicketingProvidersLoading = actionLoading(
  FETCH_TICKETING_PROVIDERS
);
export const fetchTicketingProvidersSuccess = actionSuccess(
  FETCH_TICKETING_PROVIDERS
);
export const fetchTicketingProvidersErrored = actionErrored(
  FETCH_TICKETING_PROVIDERS
);

export const fetchTicketingProvidersReset = actionReset(
  FETCH_TICKETING_PROVIDERS
);

export const fetchTicketingProviders = (name) => {
  return (dispatch) =>
    authRequest.get(
      dispatch,
      getDynamicEndpoint(name).ticketing_providers,
      fetchTicketingProvidersLoading,
      fetchTicketingProvidersSuccess,
      fetchTicketingProvidersErrored
    );
};

// REFETCH Collection seeds
// export const REFETCH_COLLECTION_SEEDS = 'REFETCH_COLLECTION_SEEDS';

// export const refetchCollectionSeedsLoading = actionLoading(
//   REFETCH_COLLECTION_SEEDS
// );
// export const refetchCollectionSeedsSuccess = actionSuccess(
//   REFETCH_COLLECTION_SEEDS
// );
// export const refetchCollectionSeedsErrored = actionErrored(
//   REFETCH_COLLECTION_SEEDS
// );

// export const refetchCollectionSeedsReset = actionReset(
//   REFETCH_COLLECTION_SEEDS
// );

// export const refetchCollectionSeeds = (name) => {
//   return (dispatch) =>
//     authRequest.get(
//       dispatch,
//       getDynamicEndpoint(name).collection_seeds,
//       refetchCollectionSeedsLoading,
//       refetchCollectionSeedsSuccess,
//       refetchCollectionSeedsErrored
//     );
// };

// // Create new collection
// export const CREATE_NEW_COLLECTION = 'CREATE_NEW_COLLECTION';

// export const createNewCollectionLoading = actionLoading(CREATE_NEW_COLLECTION);
// export const createNewCollectionSuccess = actionSuccess(CREATE_NEW_COLLECTION);
// export const createNewCollectionErrored = actionErrored(CREATE_NEW_COLLECTION);
// export const createNewCollectionReset = actionReset(CREATE_NEW_COLLECTION);

// export const createNewCollection = (data) => {
//   return (dispatch) =>
//     authRequest.post(
//       dispatch,
//       data,
//       URL.create_new_collection,
//       createNewCollectionLoading,
//       createNewCollectionSuccess,
//       createNewCollectionErrored
//     );
// };

// export const resetCreateNewCollectionState = () => {
//   return function (dispatch) {
//     dispatch(createNewCollectionReset());
//   };
// };
